// extracted by mini-css-extract-plugin
export var actionRow = "_nd-6";
export var card = "_nd-0";
export var chevron = "_nd-5";
export var content = "_nd-2";
export var details = "_nd-3";
export var eventActionToggle = "_nd-4";
export var icon = "_nd-1";
export var iconBlue = "_nd-8";
export var iconBrand = "_nd-7";
export var iconGrayBlue = "_nd-9";
export var iconGreen = "_nd-a";
export var iconIndigo = "_nd-b";
export var iconOrange = "_nd-c";
export var iconPurple = "_nd-d";
export var iconRed = "_nd-e";
export var iconWarning = "_nd-f";